const oktaConfig = {
  issuer: `${process.env.REACT_APP_OKTA_URL}/oauth2/default`,
  clientId: process.env.REACT_APP_OKTA_CLIENTID,
  redirectUri: window.location.origin + '/authorization-code/callback',
  postLogoutRedirectUri: window.location.origin,
  // endSessionRedirectUri: window.location.origin + '/logout',
    scopes: ['openid', 'profile', 'email'],
  pkce: true
};

export default oktaConfig;
